import { createContext } from 'react';

import {
  GlobalContact,
  GlobalContactPayload,
} from '@totem/components/administration/globalContacts/types';

interface GlobalContactsContextValue {
  contacts: GlobalContact[];
  loading: boolean;
  saving: boolean;
  modalOpen: boolean;
  editingContact: GlobalContact | null;
  refresh: () => void;
  openCreateModal: () => void;
  openEditModal: (contact: GlobalContact) => void;
  closeModal: () => void;
  upsertContact: (contact: GlobalContactPayload) => Promise<void>;
  deleteContact: (contactId: string) => Promise<void>;
}

const GlobalContactsContext = createContext<GlobalContactsContextValue>({
  contacts: [],
  loading: false,
  saving: false,
  modalOpen: false,
  editingContact: null,
  refresh: () => {},
  openCreateModal: () => {},
  openEditModal: () => {},
  closeModal: () => {},
  upsertContact: async () => {},
  deleteContact: async () => {},
});

export default GlobalContactsContext;
